import React, { useCallback, useState, useMemo } from 'react'
import { useSelector } from 'react-redux'

import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'

import {
    action_fetch_credit_order,
    action_fetch_card_list,
    action_init_credit_page,
    setCreditError
} from '../../../../../store/actions/pages/cart'
import {
    getCountryAppMessage,
    selectCard,
    updatebillingaddress
} from '../../../../../api'

import Page from '../../layout/normal-page'
import { Boxes, Box } from '../../layout/box'

import { useQuery } from '../../../../hooks/common'

import BillingAddress from './fragments/billing'
import OrderSummary from './fragments/summary'
import CreditPage from './credits'

import ErrorDisplay from './components/error-display'
import { useHistory, useParams } from 'react-router-dom'
import * as Paymethods from '../../../../../utils/paymethods'
import { useDispatch } from 'react-redux'
import { useEffect } from 'react'
import { useStore } from 'react-redux'
import { useLogin } from '../../../../hooks/common'
import { FormattedMessage, useIntl } from 'react-intl'
import LoadingPage from './fragments/loading-page'
import AddressEditor from '../../fragments/address/address-editor'
import Loading from '../../../../components/loading/op-loading'
import Deco from '../../components/deco'
import { v4 } from 'uuid'
import Cache from '../../../../../utils/cache'
import { TOOGLE_UI_CONFIRM, TOOGLE_UI_ALERT } from '../../../../../store/actions/ui'
import CountDown from '../../../../components/count-down'


const CreditPay = props => {
    useStyles(classes)
    const dispatch = useDispatch()
    const history = useHistory()
    const isLogin = useLogin()
    const store = useStore()
    const pageCart = useSelector(state => state.pageCart)
    const { creditOrder, cardList, creditIniting, creditError } = pageCart
    const order = creditOrder?.order
    const billingAddress = order?.billingAddress || order?.shippingDetail
    const query = useQuery()
    const { payMethod } = query
    const params = useParams()
    const [error, setError] = useState(null)
    const intl = useIntl()
    const [addressEditor, setAddressEditor] = useState({})
    const [refreshing, setRefreshing] = useState(false)
    const [deco, setDeco] = useState(null)
    const [leaved, setLeaved] = useState(false)
    const [privacyMsg, setPrivacyMsg] = useState(null)
    const redirectType = query.redirectType


    const billingFragment = useMemo(() => <BillingAddress onAddress={address => setAddressEditor({ show: true, address })} billingAddress={billingAddress} />, [billingAddress])
    const summaryFragment = useMemo(() => <OrderSummary order={order} />, [order])

    const errorHandle = useCallback(e => {
        setError(e)
    }, [])

    const closeHandle = useCallback(() => {
        setError(null)
    }, [])

    const selectCardHandle = useCallback(async card => {
        await selectCard(card?.quickpayRecord?.id)

        dispatch(action_fetch_card_list(Paymethods.getRelatedPayMethods(payMethod)))
    }, [dispatch])

    useEffect(async () => {
        if(!privacyMsg){
            const res = await getCountryAppMessage("M1840")
            if(res?.code == 200){
                // privacyMsg.current = res?.result || {}
                setPrivacyMsg(res?.result || {})
            }
        }
    }, [])

    useEffect(async () => {
        if (window.__INITIAL_STATE__) {
            // Allow the passed state to be garbage-collected
            delete window.__INITIAL_STATE__
        } else {
            CreditPay.fetchData(store, params, query, {})
        }

        window.scrollTo({
            top: 0,
        })

        // Cache.remove('temp-order')
    }, [payMethod])

    useEffect(() => {
        if (creditOrder) {
            const { openOrderResponse } = creditOrder
            if (openOrderResponse) {
                const { decoStatus, shopUrl, cartToken, checkoutId } = openOrderResponse
                if (decoStatus === 'eligible') {
                    onDeco({
                        decoStatus: 'eligible',
                        shopUrl,
                        cartToken,
                        checkoutId
                    })
                }
            }
        }
    }, [creditOrder])

    useEffect(() => {
        if(creditError){
            dispatch({
                type: TOOGLE_UI_ALERT,
                payload: {
                    show: true,
                    options: {
                        onConfirm: () => {
                            dispatch({ type: TOOGLE_UI_ALERT, payload: null })
                            dispatch(setCreditError(null))
                        },
                        content: creditError,
                    }
                }
            })
        }
    }, [creditError])

    const onDeco = useCallback(state => {
        setDeco({ ...state, key: v4() })
    }, [])

    const backHandle = e => {

        if(!leaved){
            dispatch({
                type: TOOGLE_UI_CONFIRM,
                payload: {
                    show: true,
                    options: {
                        onConfirm: () => {
                            dispatch({ type: TOOGLE_UI_CONFIRM, payload: null })
                        },
                        onCancel: () => {
                            history.goBack()
                            dispatch({ type: TOOGLE_UI_CONFIRM, payload: null })
                        },
                        content: <FormattedMessage id="cancel_info" values={{ countdown: <span style={{ color: '#e64545' }}><CountDown showHour offset={12 * 60 * 60 * 1000} /></span> }} defaultMessage="Are you sure you want to cancel payment? If your order is not paid in {countdown},it will be canceled." />,
                        okText: <FormattedMessage id="continue_to_pay" defaultMessage="Continue to Pay"/>,
                        cancelText: <FormattedMessage id="confirm_cancel" defaultMessage="Confirm Cancel"/>
                    }
                }
            })
            setLeaved(true)
        }else{
            history.goBack()
        }
        
    }

    const onSubmitAddress = async address => {
        setRefreshing(true)
        const response = await updatebillingaddress({ ...address, transactionId: order.transactionId })

        if (response?.code === 200) {
            setAddressEditor({
                address: null,
                show: false
            })
            await dispatch(action_fetch_credit_order(params.orderId, payMethod))
        }
        setRefreshing(false)
        return response
    }

    const decoSuccessHandle = result => {
        window.location.href = `/order-confirm/${result.transactionId}?transactionId=${result.transactionId}`
    }

    const decoErrorHandle = err => {
        setError({ ...err, noticeType: '2' })
    }


    return <Page showProt privacyMsg={privacyMsg} privacyPadding={true} title={intl.formatMessage({ id: 'credit_debit_card', defaultMessage: 'Credit/Debit Card' })} onBack={backHandle}>

        {
            creditIniting && <LoadingPage />
        }

        {
            !creditIniting && <CreditPage cardList={cardList} selectCardHandle={selectCardHandle} onError={errorHandle} creditOrder={creditOrder} payMethod={payMethod}>

                {
                    (payMethod !== Paymethods.__Pay_Ebanx__ && payMethod !== Paymethods.__Pay_Ebanx_Debet__) && <Boxes className={classes.Boxes}>
                        <Box>
                            {
                                billingFragment
                            }
                        </Box>
                        <Box>
                            {
                                summaryFragment
                            }
                        </Box>
                    </Boxes>
                }


            </CreditPage>
        }


        {
            <ErrorDisplay redirectType={redirectType} onDeco={onDeco} orderId={params?.orderId} show={!!error} error={error} onClose={closeHandle} />
        }

        <AddressEditor address={addressEditor?.address} onSubmit={onSubmitAddress} onClose={e => setAddressEditor({ ...addressEditor, show: false })} show={addressEditor?.show} />

        {
            refreshing && <Loading />
        }

        {
            (deco && deco.decoStatus === 'eligible') && <Deco key={deco.key} cartToken={deco.cartToken} shopUrl={deco.shopUrl} checkoutId={deco.checkoutId} onSuccess={decoSuccessHandle} onError={decoErrorHandle} />
        }

    </Page>
}

CreditPay.fetchData = async (store, params, search, headers) => {
    const { orderId } = params
    const { payMethod } = search
    await store.dispatch(action_init_credit_page(orderId, payMethod, Paymethods.getRelatedPayMethods(payMethod), headers))
}

export default CreditPay